export default __webpack_public_path__ + "static/media/953.9932894d.png";